// ISO date keys keep filtering and ordering independent of the browser time zone.
export function resumirMediosPorNegocio(registros, medios) {
  const grupos = new Map();
  for (const registro of registros) {
    if (!grupos.has(registro.negocio)) grupos.set(registro.negocio, {
      negocio: registro.negocio, medios: Object.fromEntries(medios.map(m => [m, 0])), total: 0
    });
    const grupo = grupos.get(registro.negocio);
    for (const medio of medios) grupo.medios[medio] += Number(registro[medio] || 0);
    grupo.total += Number(registro.totalDia || 0);
  }
  return [...grupos.values()].sort((a, b) => a.negocio.localeCompare(b.negocio));
}

export function fechaInforme(fecha) {
  const partes = String(fecha || "").split("/");
  if (partes.length !== 3) return "";
  const [dia, mes, anio] = partes.map(Number);
  const date = new Date(Date.UTC(anio, mes - 1, dia));
  if (date.getUTCFullYear() !== anio || date.getUTCMonth() !== mes - 1 || date.getUTCDate() !== dia) return "";
  return `${anio}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
}

export function filtrarInforme(registros, { periodo, mes, desde, hasta, negocio, permitidos }) {
  return registros.filter(r => {
    if (!permitidos.includes(r.negocio) || (negocio !== "todos" && negocio !== r.negocio)) return false;
    if (periodo === "todos") return true;
    const fecha = fechaInforme(r.fecha);
    if (!fecha) return false;
    if (periodo === "mes") return Boolean(mes) && fecha.slice(0, 7) === mes;
    return (!desde || fecha >= desde) && (!hasta || fecha <= hasta);
  }).sort((a, b) => fechaInforme(b.fecha).localeCompare(fechaInforme(a.fecha)) || a.negocio.localeCompare(b.negocio));
}
